import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import ExploreShow from './exploreShow.js';
import ExploreFilters from './exploreFilters.js';
import ExploreDataHeaderNg1 from './exploreDataHeaderNg1.js';
import ExploreWidgetTabsNg1 from './exploreWidgetTabsNg1';
import ExploreTrendWidgetWrapperController from './widgets/exploreTrendWidgetHeader';
import ExploreBreakdownModalContentWrapper from './exploreBreakdownModalContentWrapperNg1';
import ExploreHeaderComponentNg1 from './exploreHeader.ng1';
import ExploreUserGroupsModal from './userGroupsModal.js';
import ExploreMap from './exploreMap';
import ExploreTrendWidgetsComponentNg1 from './exploreTrendWidgetsNg1';

export default angular.module('app.components.explore', [
  ExploreShow.name,
  ExploreFilters.name,
  ExploreDataHeaderNg1.name,
  ExploreWidgetTabsNg1.name,
  ExploreTrendWidgetWrapperController.name,
  ExploreBreakdownModalContentWrapper.name,
  ExploreMap.name,
  ExploreHeaderComponentNg1.name,
  ExploreUserGroupsModal.name,
  ExploreTrendWidgetsComponentNg1.name,
  'ui.router'
])
  .config(function($stateProvider) {
    $stateProvider
      .state('app.explore', {
        abstract: true,
        url: '/explore/:gameId',
        template: '<ui-view/>',
        data: {
          permissions: {
            except: ['anonymous'],
            redirectTo: 'login'
          }
        },
        resolve: {
          game: function($stateParams,GamesResource){
            return GamesResource.one($stateParams.gameId).get()
              .then(game => {
                return game;
              });
          },
          gameCurrency: function($stateParams,game,currentGame){
            return game.getGameDeveloper()
              .then((gameDeveloper) => {
                game.currency = gameDeveloper.currency;
                currentGame.onNext(game);
              });
          }
        }
      })
      .state('app.explore.show', {
        abstract: true,
        url: '',
        template: '<ui-view/>',
      })
      .state('app.explore.show.new', {
        url: '',
        template: '<explore-show></explore-show>',
        resolve: {
          $title: ($filter, $stateParams) => {
            return $filter('translate')('$state.app.explore.show', {id: $stateParams.gameId});
          }
        }
      })
      .state('app.explore.show.existing', {
        url: '/group/:groupId',
        template: '<explore-show></explore-show>',
        resolve: {
          $title: ($filter, $stateParams) => {
            return $filter('translate')('$state.app.explore.show', {gameId: $stateParams.gameId, groupId: $stateParams.groupId});
          }
        }
      })
  });


/** WEBPACK FOOTER **
 ** ./src/components/explore/explore.js
 **/